import { parseBoolVariable } from '@/helpers/envs';

const {
  VUE_APP_FEATURE_DARK_THEME_AUTO: darkThemeAuto,
  VUE_APP_HIDE_AFFILIATION: hideAffiliation,
} = process.env;

const DARK_THEME_AUTO = parseBoolVariable(darkThemeAuto);
const HIDE_AFFILIATION = parseBoolVariable(hideAffiliation);

export { DARK_THEME_AUTO, HIDE_AFFILIATION };
